export default "__VITE_ASSET__74376eb6__"